import { Permission } from '../../api/models'
import { rawTransform } from '../skuit/utils'
import { API, CustomAxiosConfig } from '../skuit/types'

export class PermissionsAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (
    guid: string,
    config: CustomAxiosConfig = {},
  ): Promise<Permission[]> => {
    const response = await this.api.get(
      `/accounts/supply_chains/${guid}/users/me/permissions`,
      config,
    )
    return rawTransform(Permission)(response.data) as Permission[]
  }
}
